// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#notification-setting-edit .box-header .title[data-v-4052cb2a]{font-size:22px;font-weight:700}#notification-setting-edit .tabs[data-v-4052cb2a]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
